webpackJsonp([15024115145997],{

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _FleetBreadcrum = __webpack_require__(31);
	
	var _FleetBreadcrum2 = _interopRequireDefault(_FleetBreadcrum);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Components
	var LuxuryEs = function LuxuryEs(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page  Luxury_sub' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: ' LuxuryVehicles for Rent | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/fleet/luxury'
	      }]
	    }),
	    _react2.default.createElement(_FleetBreadcrum2.default, {
	      lang: props.pathContext.langKey,
	      currentPage: ' luxury Cars'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' Luxury'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 6
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = LuxuryEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-luxury-es-js-2bcb08f663fe31f33777.js